import React from 'react'
import jsxToString from 'jsx-to-string'
import { saveAs } from 'file-saver'
import { dayMonthYearAtTimeWithSeconds } from './dates';

class XLSXUtils {

  static downloadPortalsXLSX({ id, createdAt, movementOrder, username, destination, checkpoint, items }, portalName) {
    const xlsxTable = (<html ref={this.bodyXlsx} xmlns x="urn:schemas-microsoft-com:office:excel">
      <body >
        <table width="100%" border="0" cellpadding="0" cellspacing="10" align="center">
          <thead>
            <tr style="background-color: #5dbe9d; color: white">
              <th style="font-weight: bold">ID da operação</th>
              <th style="font-weight: bold">Data/hora Inicio</th>
              <th style="font-weight: bold">Tipo movimentação</th>
              <th style="font-weight: bold">Operador</th>
              <th style="font-weight: bold">Código do Romaneio</th>
              <th style="font-weight: bold">Ponto de Controle</th>
              <th style="font-weight: bold">Local Destino</th>
              <th style="font-weight: bold">Nome do Portal</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{id}</td>
              <td>{dayMonthYearAtTimeWithSeconds(createdAt)}</td>
              <td>{movementOrder && movementOrder.type ? movementOrder.type : ''}</td>
              <td>{username}</td>
              <td>{movementOrder && movementOrder.code ? movementOrder.code : ''}</td>
              <td>{checkpoint && checkpoint.friendlyName ? checkpoint.friendlyName : ''}</td>
              <td>{destination && destination.friendlyName ? destination.friendlyName : ''}</td>
              <td>{ portalName }</td>
            </tr>
          </tbody>
        </table>
        <br />
        <table width="100%">
          <thead>
            <tr style="background-color: #2e80ba; color: white">
              <th style="font-weight: bold">Referência</th>
              <th style="font-weight: bold">Descrição</th>
              <th style="font-weight: bold">Solicitada</th>
              <th style="font-weight: bold">Disponível</th>
              <th style="font-weight: bold">Alvo</th>
              <th style="font-weight: bold">Lida RFID</th>
            </tr>
          </thead>
          <tbody>
            {
              items.map(x => {
                return (<tr>
                  <td>{x.reference}</td>
                  <td>{x.friendlyName}</td>
                  <td>{x.quantityExpected = x.quantityExpected ? x.quantityExpected : '0'}</td>
                  <td>{x.quantityAvailable = '0'}</td>
                  <td>{x.quantityTarget = '0'}</td>
                  <td>{x.quantity = x.quantity ? x.quantity : '0'}</td>
                </tr>)
              })
            }
          </tbody>
        </table>
      </body>
    </html>)
    saveAs(new Blob([jsxToString(xlsxTable)], { type: "application/octet-stream" }), 'Relatório-Portal.xlsx');
  }
}

export default XLSXUtils



// WEBPACK FOOTER //
// ./src/utils/XLSXUtils.js